import React from 'react';

import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/models';
import { getContentFieldsByType } from '@glowforge/ui-common/models/page';

import MeetTheFamily from './meet-the-family-rebrand';

const MeetTheFamilyWidget = ({ sections, model }) => {
  const title = model?.textStrings['meet-the-family-title'];
  const productsPageLink = model?.textStrings['products-page-link'];

  const productsList = getContentFieldsByType(sections, 'list');
  const products = productsList?.map((product) => ({
    productPhoto: product.listItems[0]?.fields?.media,
    productPhotoDimensions: productsList[0].listItems[0]?.fields?.media?.fields
      ?.file?.details?.image || { height: 0, width: 0 },
    logoPhoto: product.listItems[1]?.fields?.media,
    subtitle: product.listItems[2]?.fields?.text,
    ctaButton: product.listItems[3] || {},
  }));

  return (
    <MeetTheFamily
      title={title}
      productsLink={productsPageLink}
      products={products}
    />
  );
};

MeetTheFamilyWidget.propTypes = widgetPropType;
MeetTheFamilyWidget.defaultProps = widgetDefaultProps;

export default MeetTheFamilyWidget;
